import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { isDeviceVesta, VelavuDevice } from "velavu-js-api";
import {
	DynamicSignalLabel,
	mapStrengthRSRP,
} from "../../elements/dynamic-signal";
import VelavuExpandMenu from "../../elements/velavu-expand-menu";
import VelavuSimpleTable from "../../elements/velavu-simple-table";
import { mapCellRegistrationStatus } from "../../helper/language-helper";

export default function TabTagCellular(props: {
	style?: CSSProperties;
	className?: string;
	tag: VelavuDevice;
}) {
	const { t } = useTranslation();

	if (!isDeviceVesta(props.tag) || props.tag.state?.cell === undefined)
		return null;
	const cell = props.tag.state.cell;

	return (
		<VelavuExpandMenu
			style={props.style}
			className={props.className}
			label={t("asset_detail.tag.cellular")}
		>
			<VelavuSimpleTable>
				<tbody>
					<tr>
						<td>{t("asset_detail.tag.cellular_signal")}</td>
						<td>
							<DynamicSignalLabel
								strength={mapStrengthRSRP(cell.rsrp)}
							/>
						</td>
					</tr>
					<tr>
						<td>{t("asset_detail.tag.operator")}</td>
						<td>{cell.operator_name}</td>
					</tr>
					<tr>
						<td>{t("asset_detail.tag.status")}</td>
						<td>{mapCellRegistrationStatus(cell.reg_status, t)}</td>
					</tr>
					<tr>
						<td>{t("asset_detail.tag.firmware")}</td>
						<td>{cell.fw_version}</td>
					</tr>
					<tr>
						<td>{t("asset_detail.tag.iccid")}</td>
						<td>{cell.iccid}</td>
					</tr>
					<tr>
						<td>{t("asset_detail.tag.imei")}</td>
						<td>{cell.imei}</td>
					</tr>
				</tbody>
			</VelavuSimpleTable>
		</VelavuExpandMenu>
	);
}
